import { postAsync } from 'common/fetch'

export const setBuyer = (id: number) => {
  return postAsync(`/service/setbuyer?id=${id}`)
}
